module.exports = __webpack_public_path__ + "h5/img/empty.d0169af1.png";